
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tReceipt/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tReceipt/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tReceipt/findPage',
        method: 'post',
      data
    })
}

// 查询分页数据
export const findPageByPara = (data) => {
  return axios({
    url: '/tReceipt/findPageByPara',
    method: 'post',
    data
  })
}

// 修改收货记录
export const receiptAdjustment = (data) => {
  return axios({
    url: '/tReceipt/receiptAdjustment',
    method: 'post',
    data
  })
}

// 删除收货记录
export const deleteReceipt = (data) => {
  return axios({
    url: '/tReceipt/deleteReceipt',
    method: 'post',
    data
  })
}

// 确认收货信息
export const receiptReconcile = (data) => {
  return axios({
    url: '/tReceipt/receiptReconcile',
    method: 'post',
    data
  })
}

// 获取检验明细
export const getInspectionDetail = (data) => {
  return axios({
    url: '/tReceipt/getInspectionDetail',
    method: 'post',
    data
  })
}

// 生成检验明细
export const generateInspectionDetail = (data) => {
  return axios({
    url: '/tReceipt/generateInspectionDetail',
    method: 'post',
    data
  })
}

// 获取入库标签打印数据
export const getInboundLabelData = (data) => {
    return axios({
        url: '/tReceipt/getInboundLabelData',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tReceipt.js